import { MESApiService } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash-es";

interface SettingRow {
	SettingName: string;
	Value: string | null;
}

// Reads `UTL.catSettings` FRESH (refetch on mount + on window focus) so a
// setting change takes effect the moment the user returns to the screen, no
// full page reload. The shared UTLSettingsContext only populates once per app
// mount and stays stale until reload. Shares the ["settings"] cache key so the
// Settings page's invalidate-on-save also refreshes it.
export const useFreshSetting = (name: string): string | null => {
	const { data } = useQuery({
		queryKey: ["settings"],
		queryFn: async ({ signal }): Promise<SettingRow[]> => {
			const resp = await new MESApiService().callV2(
				"[UTL].[GetSettings]",
				[],
				signal,
			);
			if (!resp.ok) throw new Error(resp.message || "Error fetching settings");
			return get(resp, "data.tables[0].rows", []) as SettingRow[];
		},
		refetchOnMount: "always",
		refetchOnWindowFocus: true,
		staleTime: 0,
	});
	return (
		(data ?? []).find((s) => s.SettingName?.trim() === name)?.Value ?? null
	);
};
